import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Box, useTheme, alpha, Divider } from '@mui/material';
import { Link } from 'react-router';
import { Icon, IconSize } from '../../../../../..';
import { disabledNavStyle, IconLink, NavbarLink } from '../../../../utils';

interface MenuListItemsProps {
  navItems: Array<IconLink | NavbarLink>;
  t: (key: string) => string;
  divider?: boolean;
  withGap?: boolean;
}

const MenuListItems: React.FC<MenuListItemsProps> = ({ navItems, t, divider = false, withGap = false }) => {
  const theme = useTheme();
  return (
    <>
      {navItems.map((item, index) => {
        if ('href' in item) {
          const { isDisabled, disabledNavStyles } = disabledNavStyle(location.pathname, item?.href);

          return (
            <Box key={`${item?.href}_${item?.translation}`}>
              <ListItem
                disablePadding
                sx={{
                  px: '8px',
                  mb: index !== navItems.length - 1 && withGap ? '5px' : 0,
                  '&:hover': { px: '8px' },
                }}
              >
                <ListItemButton
                  component={Link}
                  to={item?.href}
                  sx={{
                    width: '200px',
                    textDecoration: 'none',
                    px: '12px',
                    ...disabledNavStyles,
                    borderRadius: '6px',
                    backgroundColor: isDisabled ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
                    '&:hover': {
                      px: '12px',
                      backgroundColor: '#F9FAFB',
                    },
                  }}
                  disabled={isDisabled}
                >
                  <ListItemIcon sx={{ minWidth: '32px' }}>
                    <Icon
                      size={IconSize.MD}
                      folder={item?.iconFolder}
                      isStrokeColor={isDisabled}
                      fillColor={isDisabled ? alpha(theme.palette.primary.main, 0.6) : 'inherit'}
                    />
                  </ListItemIcon>
                  <ListItemText
                    sx={{
                      '& span': {
                        fontWeight: '600',
                        color: isDisabled ? alpha(theme.palette.primary.main, 0.8) : '#414651',
                      },
                    }}
                  >
                    {t(item?.translation)}
                  </ListItemText>
                </ListItemButton>
                {divider && <Divider />}
              </ListItem>
            </Box>
          );
        } else if ('hamburger' in item) return <Box key={`hamburger_item_${index}`}>{item?.hamburger}</Box>;
      })}
    </>
  );
};

export default MenuListItems;
